<div class="home4-theme">
  <app-banner></app-banner>
  <app-services-section></app-services-section>
  <app-address-section></app-address-section>
</div>
